import showError from '@/handler/error';
import { apiConfig } from '../api-config';

export const getReadNotification = async (idUser: string) => {
  const uri = `api/GenericRead/get-id-user?idUser=${idUser}`;
  return apiConfig
    .post(`${uri}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(({ data }) => data)
    .catch(showError);
};
